import { MouseEvent } from 'react';
import { useState } from 'react';
import useGetPharmacyHandlingMedicines from './useGetPharmacyHandlingMedicines';
import {
  MedicineStandardPriceVo,
  PharmacyHandlingMedicineList,
} from '@/@types/medicine';
import useSetMarkMedicineStandardAsAvailable from './useSetMarkMedicineStandardAsAvailable';
import useSetMarkMedicineStandardAsSoldOut from './useSetMarkMedicineStandardAsSoldOut';

interface UseMedicineListViewModel {
  medicines: PharmacyHandlingMedicineList;
  editingMedicineId?: string;
  onChangeMedicineModalStatus: (isEdit?: boolean, medicineId?: string) => void;
  onChangeSoldOutStatus: (
    e: MouseEvent,
    medicineId: string,
    medicineStandarPrice: MedicineStandardPriceVo
  ) => void;
  toastMessage: string;
  onClearToastMessage: () => void;
  isMedicineModalOpen: boolean;
  page: number;
  setPage: (page: number) => void;
}

export const MEDICINE_PAGE_LIMIT = 10;

const useMedicineListViewModel = (): UseMedicineListViewModel => {
  const [editingMedicineId, setEditingMedicineId] = useState<string>();
  const [isMedicineModalOpen, setIsMedicineModalOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState<string>('');
  const [page, setPage] = useState<number>(1);

  const { medicines } = useGetPharmacyHandlingMedicines({
    page,
    limit: MEDICINE_PAGE_LIMIT
  });

  // 약품 품절 처리 on/off
  const { setMarkMedicineStandardAsAvailableMutate } =
    useSetMarkMedicineStandardAsAvailable();
  const { setMarkMedicineStandardAsSoldOutMutate } =
    useSetMarkMedicineStandardAsSoldOut();

  // 약품 추가/수정 모달 on/off
  const onChangeMedicineModalStatus = (
    isEdit?: boolean,
    medicineId?: string
  ) => {
    if (isEdit && !medicineId) return;

    setIsMedicineModalOpen(!isMedicineModalOpen);
    if (medicineId) {
      setEditingMedicineId(medicineId);
      return;
    }
    setEditingMedicineId(undefined);
  };

  // 약품 품절 처리 성공시
  const onSuccessMutate = (successMessage: string) => {
    setToastMessage(successMessage);
  };

  // 약품 품절 처리
  const onChangeSoldOutStatus = (
    e: MouseEvent,
    medicineId: string,
    medicineStandarPrice: MedicineStandardPriceVo
  ) => {
    e.stopPropagation();

    if (medicineStandarPrice.isSoldOut) {
      setMarkMedicineStandardAsAvailableMutate(
        {
          medicineId,
          medicineStandardId: medicineStandarPrice.medicineStandardId
        },
        {
          onSuccess: () => onSuccessMutate('품절 해제 처리가 완료되었어요.')
        }
      );
      return;
    }
    setMarkMedicineStandardAsSoldOutMutate(
      {
        medicineId,
        medicineStandardId: medicineStandarPrice.medicineStandardId
      },
      {
        onSuccess: () => onSuccessMutate('품절 처리가 완료되었어요.')
      }
    );
  };

  // 토스트 메시지 삭제
  const onClearToastMessage = () => {
    setToastMessage('');
  };

  return {
    medicines,
    editingMedicineId,
    onChangeMedicineModalStatus,
    onChangeSoldOutStatus,
    toastMessage,
    onClearToastMessage,
    isMedicineModalOpen,
    page,
    setPage
  };
};

export default useMedicineListViewModel;
